import * as angular from 'angular';

import { ComponentDefinition, LogLevel } from '../../../../models';
import { IConfigurationService, ILoggerService } from '../../../../services';

class LogLevelsController implements angular.IComponentController {
    isLevelLoading = true;
    levels: { apiLevel: LogLevel; serviceLevel: LogLevel; enableExecutionTimeLogging: boolean };
    enableExecutionTimeLogging: false;

    static $inject = [
        'configurationService',
        'translatedLoggerService'
    ];

    constructor(
        private _configurationService: IConfigurationService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this._configurationService
            .getLogLevels()
            .then(levels => {
                this.levels = levels;
                this.isLevelLoading = false;
            });
    }

    saveLogLevels() {
        this._configurationService.setLogLevels(this.levels.apiLevel, this.levels.serviceLevel, this.levels.enableExecutionTimeLogging)
            .then(() => this._loggerService.logSuccess('Saved'))
            .catch(reason => {
                console.error(reason);
                this._loggerService.logError('Log level has not been saved');
            });
    }
}

export const wtLogLevels: ComponentDefinition = {
    componentId: 'wtLogLevels',
    controller: LogLevelsController,
    template: require('./logLevels.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};